<!-- Modal Header -->
<div class="modal-header">
    <h5 class="modal-title">
        <i class="ti ti-file-invoice me-2"></i>
        Parcelamentos PGFN
    </h5>
    <button type="button" class="btn-close" (click)="close()"></button>
</div>

<!-- Modal Body -->
<div class="modal-body">
    <app-loading-overlay [show]="isLoading"/>

    <!-- Company Info Card -->
    @if (company) {
        <div class="company-info-card mb-3">
            <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="flex-grow-1">
                    <h5 class="mb-2">{{ company.name }}</h5>
                    <div class="row">
                        <div class="col-md-6">
                            <p class="mb-2">
                                <span (click)="copy(company.documentNumber)" class="cursor-pointer">
                                    <strong>{{ PersonTypeHelper.getLabel(company.personType) }}:</strong> {{ company.documentNumber | cpfCnpj }}
                                    <i class="ti ti-copy cursor-pointer ms-1"></i>
                                </span>
                                <br>
                                @if (company.segment) {
                                    <strong>Segmento:</strong>
                                    <span>{{ company.segment }}</span><br>
                                }
                                @if (company.companySize) {
                                    <strong>Porte:</strong>
                                    <span>{{ company.companySize }}</span><br>
                                }
                                @if (company.registrationStatus) {
                                    <strong>Situação:</strong>
                                    <span class="badge bg-dark text-white">
                                        {{ company.registrationStatus }}
                                    </span>
                                }
                            </p>
                        </div>
                        <div class="col-md-6">
                            <p class="mb-2">
                                <strong>Contato:</strong><br>
                                @if (company.email) {
                                    <span>
                                        <i class="ti ti-mail"></i> {{ company.email }}<br>
                                    </span>
                                }
                                @if (company.phones && company.phones.length > 0) {
                                    @for (phone of company.phones; track $index) {
                                        <app-phone [areaCode]="phone.ddd" [phone]="phone.number" [isFax]="phone.isFax"/>
                                    }
                                }
                            </p>
                        </div>
                    </div>
                    @if (getFullAddress(company)) {
                        <p class="mb-0">
                            <strong>Endereço:</strong><br>
                            <i class="ti ti-map-pin"></i> {{ getFullAddress(company) }}
                        </p>
                    }
                    @if (company.partners && company.partners.length > 0) {
                        <div class="mt-2">
                            <strong>Sócios:</strong><br>
                            @for (partner of company.partners; track $index) {
                                <small class="d-block text-muted">
                                    • {{ partner.name }}
                                    @if (partner.qualification) {
                                        - {{ partner.qualification }}
                                    }
                                </small>
                            }
                        </div>
                    }
                </div>
                <div class="action-buttons">
                    <button class="btn btn-sm btn-outline-primary" (click)="viewCompanyDetails(company.id)">
                        <i class="ti ti-building-skyscraper me-1"></i>
                        Ver Empresa
                    </button>
                    @if (company?.documentNumber && PersonTypeHelper.isPJ(company?.personType)) {
                        <button class="btn btn-sm btn-outline-secondary mt-2" (click)="enrichByDocumentNumber(company.documentNumber)">
                            <i class="ti ti-refresh me-1"></i>
                            Atualizar
                        </button>
                    }
                </div>
            </div>
            @if (company.dataSource) {
                <small class="text-muted">
                    <i class="ti ti-info-circle me-1"></i>
                    Fonte: {{ company.dataSource }}
                </small>
            }
        </div>
    }

    <!-- Debts Table -->
    <div class="debts-table-container">
        <h6 class="mb-3">
            <i class="ti ti-list me-2"></i>
            Detalhamento de Parcelamentos
            @if (debts.length > 0) {
                <span class="badge bg-primary ms-2">{{ debts.length }}</span>
            }
        </h6>

        <app-table [tableData]="debts">
            <!-- Header da Tabela -->
            <ng-template app-table-header>
                <th scope="col">Parcelamento</th>
                <th scope="col">VC <i class="ti ti-info-circle ms-1" ngbTooltip="Valor Consolidado do Parcelamento"></i></th>
                <th scope="col">QP <i class="ti ti-info-circle ms-1" ngbTooltip="Quantidade Total de Parcelas"></i></th>
                <th scope="col">PP <i class="ti ti-info-circle ms-1" ngbTooltip="Quantidade de Parcelas Pagas"></i></th>
                <th scope="col">PR <i class="ti ti-info-circle ms-1" ngbTooltip="Quantidade de Parcelas Restantes"></i></th>
                <th scope="col">Parc. Atual (Est.)</th>
                <th scope="col">Saldo Dev. (Est.)</th>
                <th scope="col">TN <i class="ti ti-info-circle ms-1" ngbTooltip="Tipo de Negociação"></i></th>
                <th scope="col">Status</th>
                <th scope="col" class="text-end">Ações</th>
            </ng-template>

            <!-- Body da Tabela -->
            <ng-template app-table-body let-debt>
                <td>
                    <div class="d-flex flex-column">
                        <strong>{{ debt.installmentNumber }}</strong>
                        <small class="text-muted d-flex align-items-center">
                            <i class="ti ti-calendar ti-sm me-1"></i>
                            {{ debt.monthInstallment }}
                        </small>
                    </div>
                </td>
                <td>
                    <strong>{{ (debt.consolidatedValue || 0)  | currency }}</strong>
                </td>
                <td>
                    {{ debt.totalInstallments || 0 }}
                </td>
                <td>
                    {{ debt.totalInstallmentPaid || 0 }}
                </td>
                <td>
                    {{ debt.totalInstallmentRemaining || 0 }}
                </td>
                <td>
                    <strong>{{ (debt.estimatedInstallmentValue || 0) | currency }}</strong>
                </td>
                <td>
                    <strong>{{ (debt.estimatedDebtValue || 0) | currency }}</strong>
                </td>
                <td>
                    <strong
                            [ngbTooltip]="debt.negotiationType"
                            placement="top">
                        {{ NegotiationTypeHelper.getAbbreviation(debt.negotiationType) }}
                    </strong>
                </td>
                <td>
                    <span [class]="getStatusBadgeClass(debt.negotiationStatus || '')">
                        {{ getStatusLabel(debt.negotiationStatus) }}
                    </span>
                </td>
                <td class="text-end">
                    <button
                            class="btn btn-sm btn-dark"
                            (click)="openDetailsModal(debt)"
                            title="Ver detalhes">
                        <i class="ti ti-eye"></i>
                    </button>
                </td>
            </ng-template>
        </app-table>

        @if (!isLoading && debts.length === 0) {
            <div class="alert alert-info">
                <i class="ti ti-info-circle me-2"></i>
                Nenhum parcelamento encontrado para esta empresa.
            </div>
        }
    </div>
</div>
